import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_8cd234c4: FaireBrandEntity = {
  token: "b_8cd234c4",
  type: "brand",
  name: "Palermo Body",
  avatarUrl:
    "https://cdn.faire.com/fastly/032cbde9480faafef2f9cf2b627712ab6634c2421ba3938f60efebd1a4411d2b.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/1263c86266eb729a10d90db4bb2d9f944951d61ecbcac8dff67d0f85b08e0704.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/032cbde9480faafef2f9cf2b627712ab6634c2421ba3938f60efebd1a4411d2b.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/1263c86266eb729a10d90db4bb2d9f944951d61ecbcac8dff67d0f85b08e0704.jpeg",
  location: "Brooklyn, NY, USA",
  minimumOrderDollars: 205,
  rating: 4.9,
  reviewCount: 35,
  isTopShop: true,
  isInsider: true,
  description:
    "Palermo Body is a botanical skincare and wellness line inspired by founder Jessica Morelli's Sicilian heritage. Each Palermo product begins with an aromatherapeutic intention, and is formulated by Jessica using earth-derived ingredients, selected to help your customers feel their best, naturally. Made by hand in Brooklyn, NY.\n",
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:45:01.522Z",
    importedBy: "entity-db-cli",
  },
};
